export default __webpack_public_path__ + "assets/images/logo2.30c45ad1.png";